import CardtabLayout from './CardtabLayout.vue';

export default CardtabLayout;



// WEBPACK FOOTER //
// ./src/uikit/layouts/cardtablayout/CardtabLayout/index.ts